exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".indexCarousel__carouselImage___IUV8z {\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  width: 100%;\n  height: 100%; }\n\n.indexCarousel__playIcon___2j5hx {\n  position: absolute; }\n\ndiv > .indexCarousel__playIcon___2j5hx {\n  width: 50px;\n  height: 35px;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%); }\n\n.indexCarousel__bottomControls___3Baoz {\n  position: absolute;\n  bottom: 20px;\n  left: 15px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  z-index: 2; }\n\n.indexCarousel__fullscreenIcon___2JIgB {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  padding: 0;\n  z-index: 2;\n  background: rgba(0, 0, 0, 0.5);\n  border-radius: 4px;\n  padding: 6px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-size: 18px; }\n  .indexCarousel__fullscreenIcon___2JIgB:hover {\n    background: rgba(0, 0, 0, 0.7); }\n", ""]);

// exports
exports.locals = {
	"carouselImage": "indexCarousel__carouselImage___IUV8z",
	"playIcon": "indexCarousel__playIcon___2j5hx",
	"bottomControls": "indexCarousel__bottomControls___3Baoz",
	"fullscreenIcon": "indexCarousel__fullscreenIcon___2JIgB"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/IndexCarousel/indexCarousel.scss
// module id = 2035
// module chunks = 6